// File Metadata:
// Filename: App.js
// Version: 1.00
// Created: 2022-08-23 17:19:08
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import DashHome from './pages/DashHome'
import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './features/auth/Login'
import Layout from './components/Layout'
import Home from './pages/Home'
import PersistLogin from './features/auth/PersistLogin' // Fix import path
import RequireAuth from './features/auth/RequireAuth'
import Prefetch from './features/auth/Prefetch'
import useTitle from './hooks/useTitle'
import { ROLES } from './config/roles'
import DashLayout from './components/DashLayout'
import EditReception from './features/reception/EditReception'
import NewReception from './features/reception/NewReception'
import UsersList from './features/users/UsersList'
import EditUser from './features/users/EditUser'
import NewUserForm from './features/users/NewUserForm'
import VendorsDataGrid from './features/vendors/VendorsDataGrid'
import EditVendor from './features/vendors/EditVendor'
import NewVendor from './features/vendors/NewVendor'
import EditShipmentlog from './features/shipmentlog/EditShipmentlog'
import NewShipmentLog from './features/shipmentlog/NewShipment/NewShipmentLog'
import TaskBoard from './features/taskboard/TaskBoard'
import CrossdockList from './features/crossdock/CrossdockList'
import NewArrival from './features/crossdock/Arrival/NewArrival'
import NewDeparture from './features/crossdock/Departure/NewDeparture'
import EditCrossdock from './features/crossdock/EditCrossdock'
import QualityDashboard from './features/reception/QualityAssessment/QualityDashboard'
import ReceptionsDataGrid from './features/reception/ReceptionsDataGrid'
import ShipmentLogDataGrid from './features/shipmentlog/ShipmentLogDataGrid'
import UserDashboard from './features/users/components/UserDashboard'
import CrewManagement from './features/users/components/crew/CrewManagement'
import ReportManager from './features/users/components/reports/ReportManager'
import CrewDetails from './features/users/components/crew/CrewDetails'
import CrewSchedule from './features/users/components/crew/CrewSchedule'
import CrewRotationPlanner from './features/users/components/crew/CrewRotationPlanner'

// Consolidate crew management routes under the ManagementRoutes component

const App = () => {
    useTitle('Deceuninck - Inbound Dashboard')
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                {/* Public Routes */}
                <Route index element={<Home />} />
                <Route path="login" element={<Login />} />

                {/* Protected Routes */}
                <Route element={<PersistLogin />}>
                    <Route element={<RequireAuth allowedRoles={{ Employee: true }} />}>
                        <Route element={<Prefetch />}>
                            <Route path="dash" element={<DashLayout />}>
                                <Route index element={<DashHome />} />

                                <Route path='shipments'>
                                    <Route index element={<ShipmentLogDataGrid />} />
                                    <Route path=':id' element={<EditShipmentlog />} />
                                    <Route path='new' element={<NewShipmentLog />} />
                                </Route>

                                <Route path='vendors'>
                                    <Route index element={<VendorsDataGrid />} />
                                    <Route path=':id' element={<EditVendor />} />
                                    <Route path='new' element={<NewVendor />} />
                                </Route>

                                <Route path='receptions'>
                                    <Route index element={<ReceptionsDataGrid />} />
                                    <Route path=':id' element={<EditReception />} />
                                    <Route path=':id/quality' element={<QualityDashboard />} />
                                    <Route path='new' element={<NewReception />} />
                                </Route>

                                <Route path='taskboard'>
                                    <Route index element={<TaskBoard />} />
                                </Route>

                                 <Route path='crossdock'>
                                    <Route index element={<CrossdockList />} />
                                    <Route path=':id' element={<EditCrossdock />} />
                                    <Route path='arrival/new' element={<NewArrival />} />
                                    <Route path='departure/new' element={<NewDeparture />} />
                                </Route>

                                <Route element={<RequireAuth allowedRoles={{ Admin: true, Coordinator: true, Voorman: true }} />}>
                                    <Route path='users'>
                                        <Route index element={<UsersList />} />
                                        <Route path=':id' element={<EditUser />} />
                                        <Route path='new' element={<NewUserForm />} />
                                    </Route>
                                </Route>

                                <Route element={<RequireAuth allowedRoles={{Manager: true, Admin: true }} />}>
                                    <Route path="users">
                                        <Route index element={<UsersList />} />
                                        <Route path=":id" element={<UserDashboard />} />
                                    </Route>
                                    <Route path="crews" element={<CrewManagement />} />
                                    <Route path="user-reports" element={<ReportManager />} />
                                </Route>
                                <Route element={<RequireAuth allowedRoles={{Manager: true, Admin: true }} />}>
                                    <Route path="crews">
                                        <Route index element={<CrewManagement />} />
                                        <Route path=":id" element={<CrewDetails />} />
                                        <Route path="schedule" element={<CrewSchedule />} />
                                        <Route path="rotation" element={<CrewRotationPlanner />} />
                                    </Route>
                                </Route>
                            </Route>
                        </Route>
                    </Route>
                    {/* End require auth */}
                </Route>
                {/* End persist login */}
            </Route>
        </Routes>
    )
}

export default App
